var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-group",
    {
      attrs: { value: _vm.searchUserAndCompany },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function() {
            return [
              _vm.isUser
                ? _c("v-list-item-title", [_vm._v(_vm._s(_vm.$tc("User", 2)))])
                : _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.$tc("Company", 2)))
                  ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm._l(_vm.filteredAssignees, function(user, index) {
        return _c(
          "v-list-item",
          {
            key: index,
            staticStyle: { "padding-left": "0px" },
            attrs: { dense: "" },
            on: {
              click: function($event) {
                _vm.activityMenu
                  ? _vm.$emit("addCompanyOrUser", user)
                  : _vm.$emit("addIndividualUser", user)
              }
            }
          },
          [
            _c(
              "v-list-item-avatar",
              { attrs: { height: "25px", width: "25px", "min-width": "25px" } },
              [_c("v-img", { attrs: { src: user.image, sizes: "small" } })],
              1
            ),
            _vm._v(" "),
            _c(
              "v-list-item-content",
              [
                _vm.isUser
                  ? _c("v-list-item-subtitle", {
                      domProps: {
                        innerHTML: _vm._s(
                          user.first_name + " " + user.last_name
                        )
                      }
                    })
                  : _c("v-list-item-subtitle", {
                      domProps: { innerHTML: _vm._s(user.name) }
                    })
              ],
              1
            )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4634fb20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4634fb20","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/WorkOrderForm/_Molecules/AssignmentMenuListItem.vue
// module id = null
// module chunks = 